define('bizzabo/views/right/CommunityPreviewView',['backbone',
    'underscore',
    'bizzabo/views/popup/PopupView',
    'hbars!bizzabo/templates/communityPreview'],
function(Backbone,
         _,
         PopupView,
         template) {

    var CommunityPreviewView = PopupView.extend({
        className: 'community-preview-view',

        events : {
            'click .push-message-box-tab' : 'tabClicked'
        },

        initialize : function() {
            this.popUpInitialize();
        },

        render : function() {
            var html = template(this.model.toJSON());
            this.$el.html(html);
            return this;
        },

        tabClicked : function(e) {
            var types = {
                mobile : false,
                web : false,
                mail : false
            };

            var clickedType = $(e.target).attr('name');
            types[clickedType] = true;
            _.each(types, function(value, key) {
                this.$('.push-message-box-tab.' + key).toggleClass('selected', value);
                this.$('.push-messages-image.' + key).toggleClass('hide', !value);
            })
        }

    });

    return CommunityPreviewView;

});
